import { defineMessages } from 'react-intl';

export const artistSwitcherMessages = defineMessages({
  // design: navigation i1/i3. The rail tooltip, and the accessible name of the rail slot and the compact pill.
  tooltip: { id: 'app.sml.artistSwitcher.tooltip', defaultMessage: 'Artist: {name} · Switch' },
  header: { id: 'app.sml.artistSwitcher.header', defaultMessage: 'Artists' },
  count: { id: 'app.sml.artistSwitcher.count', defaultMessage: '{count} / {limit}' },
  add: { id: 'app.sml.artistSwitcher.add', defaultMessage: 'Add artist' },
});
